import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {formatNumber, isEmpty, validationChecker} from "../../../../components/commonmethod/CommonMethod";
import Th_title from "../../../../components/Th_title";
import {saveDepreciation} from "../../../../api/asset/AssetDepreciationService";
import {SelectComboBoxForCreate} from "../../../../components/select/SelectComboBoxForCreate";
import {onCreateClickListener} from "../../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../../components/selector/Selector";
import {inputOnChange} from "../../../../components/commonmethod/simmsInputMethod";
import SimmsInput from "../../../../components/input/SimmsInput";
import {dateOnChange} from "../../../../components/commonmethod/simmsDateMethod";
import SimmsDatePicker from "../../../../components/datepicker/SimmsDatePicker";
import {apiLoading} from "../../../../redux/slice/apiSlice";
import {useDispatch, useSelector} from "react-redux";
import {handleActiveError, handleActiveToast} from "../../../../components/sonner/ToastBasic";
import {useCacheRefresh} from "../../../../hooks/useCacheRefresh";
import {CacheType, CodeSpecNum} from "../../../../constant/CodeSpecNum";
import SimmsInputSearch from "../../../../components/input/SimmsInputSearch";
import SimmsDrawerSearch from "../../../../components/drawer/simms/SimmsDrawerSearch";
import DepreciationCalcTable from "./components/DepreciationCalcTable";
import {
    DetailKvTable,
    DetailFormPageShell,
    DetailListPage,
    DetailPanel,
    DetailSummaryButton,
} from "../../../../components/detailLayout";
import "../../../../components/detailLayout/detailListLayout.css";

export const depreciationItem = [
    {id: "동산", name: "동산"},
    {id: "건물", name: "건물"}
];

export const depreciationType = [
    {id: "정률법", name: "정률법", text: "감가상각률(단위 : %)"},
    {id: "정액법", name: "정액법", text: "잔존가치"}
];

export const depreciationYear = [
    {id: "1", name: "1년"},
    {id: "2", name: "2년"},
    {id: "3", name: "3년"},
    {id: "4", name: "4년"},
    {id: "5", name: "5년"},
    {id: "6", name: "6년"},
    {id: "7", name: "7년"},
    {id: "8", name: "8년"},
    {id: "9", name: "9년"},
    {id: "10", name: "10년"},
    {id: "11", name: "11년"},
    {id: "12", name: "12년"},
    {id: "13", name: "13년"},
    {id: "14", name: "14년"},
    {id: "15", name: "15년"},
    {id: "16", name: "16년"},
    {id: "17", name: "17년"},
    {id: "18", name: "18년"},
    {id: "19", name: "19년"},
    {id: "20", name: "20년"},
];

function AssetDepreciationCreate() {
    const platFrom = useSelector(state => state.auth.platFrom);
    const [depreciation, setDepreciation] = useState({type: "정률법"});
    const [calc, setCalc] = useState([]);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const refreshCache = useCacheRefresh();
    const requireds = ["asset", "item", "type", "year", "rate", "depreciationDate", "price"];

    const calcAndReturnList = (data) => {
        const list = [];
        let map = {};
        if (data) {
            const type = data.type;
            const ls = data.year;
            let price = data.price;
            const rate = data.rate;
            const dateSplit = data.depreciationDate != null ? data.depreciationDate.split("T")[0].split("-") : null;
            let sum = 0;

            if (type === "정률법") {
                if (rate > 100) {
                    alert("감가상각률은 100%를 넘을 수 없습니다.");
                    setDepreciation((prev) => ({
                        ...prev,
                        rate: null,
                        required_validate: {...prev.required_validate, rate: false}
                    }));
                    return [];
                }
            } else if (type === "정액법") {
                if (rate > price) {
                    alert("잔존가치는 취득가액을 넘을 수 없습니다.");
                    setDepreciation((prev) => ({
                        ...prev,
                        rate: null,
                        required_validate: {...prev.required_validate, rate: false}
                    }));
                    return [];
                }
            }

            for (let i = 0; i < ls; i++) {
                const dateText = (parseInt(dateSplit[0]) + i) + "-" + dateSplit[1] + "-" + dateSplit[2];
                if (type === "정률법") {
                    const ll = Math.floor(price * rate / 100);
                    price = price - ll;
                    sum += ll;

                    map = {
                        year: dateText,
                        annual: i + 1 + "년차",
                        amount: formatNumber(ll),
                        accumulated: formatNumber(sum),
                        remain: formatNumber(price)
                    };
                } else if (type === "정액법") {
                    const ll = Math.floor((price - rate) * (1 / ls));
                    sum += ll;

                    map = {
                        year: dateText,
                        annual: i + 1 + "년차",
                        amount: formatNumber(ll),
                        accumulated: formatNumber(sum),
                        remain: formatNumber(price - sum)
                    };
                }

                list.push(map);
            }
        }
        return list;
    };

    useEffect(() => {
        if (depreciation?.type && depreciation?.year && depreciation?.price && depreciation?.rate && depreciation?.depreciationDate) {
            setCalc(calcAndReturnList(depreciation));
        } else {
            setCalc([]);
        }
    }, [depreciation]);

    const create = async () => {
        if (!validationChecker(depreciation)) return;

        if (requireds.some(e => isEmpty(depreciation[e]))) {
            alert("필수값이 누락되었습니다.");
            return;
        }

        dispatch(apiLoading(true));

        await saveDepreciation(depreciation).then(response => {
            if (response.status === 200) {
                handleActiveToast({message: "등록되었습니다."});
                refreshCache(CacheType.asset);
                const newId = response.data?.id;
                if (newId) {
                    navigate(`/asset/depreciation/${newId}`, {state: {id: newId}});
                } else {
                    navigate("/asset/depreciation");
                }
            } else if (response.status === 201 || response.status === 202) {
                handleActiveError({message: response.data.title, description: response.data.reason});
            } else if (response.status === 413) {
                handleActiveError({message: "첨부파일 용량이 너무 큽니다."});
            } else {
                handleActiveError({message: "등록에 실패하였습니다."});
            }
        }).finally(() => dispatch(apiLoading(false)));
    };

    const rateLabel = depreciation.type && depreciationType.find(item => item.name === depreciation.type)?.text;

    return (
        <DetailFormPageShell
            className="common-container container-height-full border-l-gray create-page detail-list-layout asset-detail-list-layout"
            title="감가상각 등록"
            meta="신규 감가상각 정보를 입력하세요"
            actions={
                <>
                    <DetailSummaryButton muted onClick={() => navigate("/asset/depreciation")}>
                        취소
                    </DetailSummaryButton>
                    <DetailSummaryButton
                        onClick={() => {
                            if (window.confirm("등록 하시겠습니까?")) {
                                create();
                            }
                        }}
                    >
                        등록
                    </DetailSummaryButton>
                </>
            }
        >
            <DetailListPage isEditing className="flex min-h-0 flex-1 flex-col">
                <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                    <div className="asset-detail-list-scroll detail-list-scroll">
                        <DetailPanel title="기본정보">
                            <DetailKvTable>
                                <tbody>
                                <tr>
                                    <Th_title title="자산명" colspan={3} className="fieldset-td relative align-top" required auth>
                                        <Selector
                                            onChange={(v) => onCreateClickListener(setDepreciation, "asset", depreciation.asset, v, true)}
                                            data={depreciation.asset}
                                            entity="depreciationAsset"
                                            uniqueKey="depreciationAsset"
                                        >
                                            <SimmsInputSearch type="TEXT" placeHolder="자산명"/>
                                            <SimmsDrawerSearch showLabel title="자산그룹" entity="code" target="group" parentKey={CodeSpecNum.AssetGroupCode} uniqueKey="group" recursive/>
                                            <SimmsDrawerSearch showLabel title="업무그룹" entity="code" target="task" parentKey={CodeSpecNum.TaskGroupCode} uniqueKey="task" recursive/>
                                            <SimmsDrawerSearch showLabel title="자산위치" entity="code" target="location" parentKey={CodeSpecNum.AssetLocation} uniqueKey="location" recursive/>
                                            {platFrom === "ITM" && (
                                                <SimmsDrawerSearch showLabel title="SLA 그룹" entity="code" target="slaGroup" parentKey={CodeSpecNum.SlaGroupCode} uniqueKey="slaGroup" recursive/>
                                            )}
                                            <SimmsDrawerSearch showLabel title="운영담당자" entity="userAccount" target="operator"/>
                                            <SimmsDrawerSearch showLabel title="자산사용자" entity="userAccount" target="handler"/>
                                        </Selector>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="자산항목" colspan={1} className="fieldset-td" required auth>
                                        <SelectComboBoxForCreate target="item" options={depreciationItem} data={{data: depreciation, fnc: setDepreciation}}/>
                                    </Th_title>
                                    <Th_title title="계산방법" colspan={1} className="fieldset-td" required auth>
                                        <SelectComboBoxForCreate target="type" options={depreciationType} data={{data: depreciation, fnc: setDepreciation}} defaultValue="정률법"/>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="내용연수" colspan={1} className="fieldset-td" required auth>
                                        <SelectComboBoxForCreate target="year" options={depreciationYear} data={{data: depreciation, fnc: setDepreciation}}/>
                                    </Th_title>
                                    <Th_title title={rateLabel} colspan={1} className="fieldset-td" required auth>
                                        <SimmsInput onChange={(v) => inputOnChange(setDepreciation, "rate", v, true)} data={depreciation.rate}/>
                                    </Th_title>
                                </tr>
                                <tr>
                                    <Th_title title="취득 일자" colspan={1} className="fieldset-td" required auth>
                                        <SimmsDatePicker onChange={(v) => dateOnChange(setDepreciation, "depreciationDate", v, true)} data={depreciation.depreciationDate}/>
                                    </Th_title>
                                    <Th_title title="취득가액(단위 : 원)" colspan={1} className="fieldset-td" required auth>
                                        <SimmsInput onChange={(v) => inputOnChange(setDepreciation, "price", v, true)} data={depreciation.price}/>
                                    </Th_title>
                                </tr>
                                </tbody>
                            </DetailKvTable>
                        </DetailPanel>

                        <DetailPanel title="계산">
                            <DepreciationCalcTable rows={calc}/>
                        </DetailPanel>
                    </div>
                </div>
            </DetailListPage>
        </DetailFormPageShell>
    );
}

export {AssetDepreciationCreate};
